//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentUnsavedChangesModal",
  components: {
    GenericModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    handleConfirm() {
      this.hideModal();
      this.$emit("confirm");
    }
  }
});